import { ReactNode, type FunctionComponent } from 'react';
import classes from './StepHeader.module.css';

export interface StepHeaderProps {
  title: string;
  children: ReactNode;
}

const StepHeader: FunctionComponent<StepHeaderProps> = ({
  title,
  children,
}) => {
  const intro =
    typeof children === 'string' || children instanceof String ? (
      <p className={classes.intro}>{children}</p>
    ) : (
      children
    );

  return (
    <header className={classes.root}>
      <h1 className={classes.title}>{title}</h1>
      {intro && <div className={classes.intro}>{intro}</div>}
    </header>
  );
};

export default StepHeader;
